import { useEffect, useRef, useState } from "react";

export const useProductGallery = ({ data }) => {
  const imageRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [localLoading, setLocalLoading] = useState(true);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomStyle, setZoomStyle] = useState({});
  const [touchStart, setTouchStart] = useState(0);

  /* ZOOM */
  const handleMouseMove = (e) => {
    if (!imageRef.current) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setZoomStyle({
      transformOrigin: `${x}% ${y}%`,
      transform: "scale(1.8)",
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({
      transform: "scale(1)",
      transformOrigin: "center center",
    });
  };

  /* MOBILE SWIPE */
  const handleSwipe = (touchEndX) => {
    if (!selectedColor?.product_media?.length) return;

    const diff = touchStart - touchEndX;
    const images = selectedColor.product_media;
    const currentIndex = images.findIndex(
      (img) => img.media === selectedImage
    );

    if (diff > 50 && currentIndex < images.length - 1) {
      setSelectedImage(images[currentIndex + 1].media);
    }

    if (diff < -50 && currentIndex > 0) {
      setSelectedImage(images[currentIndex - 1].media);
    }
  };

  /* DATA INIT */
  useEffect(() => {
    if (!data) return;

    setLoading(true);
    setLocalLoading(true);

    const firstColor =
      data?.product_sizes?.[0]?.product_colors?.[0] || null;

    setSelectedColor(firstColor);
    setSelectedImage(
      firstColor?.product_media?.[0]?.media || null
    );

    setLoading(false);
    setLocalLoading(false);
  }, [data]);

  return {
    loading,
    localLoading,
    selectedImage,
    selectedColor,
    zoomStyle,
    imageRef,
    setSelectedImage,
    handleMouseMove,
    handleMouseLeave,
    handleSwipe,
    setTouchStart,
  };
};